package ar.corzo.health_tracker.utils

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.plus
import kotlinx.coroutines.cancel
import react.useEffectWithCleanup
import react.useMemo

fun rememberScope(): CoroutineScope {
    val scope = useMemo {
        MainScope() + SupervisorJob()
    }
    useEffectWithCleanup(emptyList<Any>()) {
        onCleanup {
            scope.cancel()
        }
    }
    return scope
}